import React from 'react';
import { useTranslation } from 'react-i18next';
import { useSearchParams } from 'react-router-dom';
import styled from 'styled-components';

const MainContainerProjet = styled.main`
    background: rgb(246,246,246);
    padding-bottom: 175px;

    .capitalize {
        display: inline-block;
        &:first-letter {
            text-transform: capitalize;
        }
    }

    > div {
        margin: auto;
        width : min(1440px,100vw - 40px);
        padding-top: 100px;

        > span.catégorie {
            font-size: 15px;
            font-weight: bold;
            text-transform: uppercase;
            color: blue;
        }

        > h1 {
            font-size: 70px;
            color: #000000;
            margin-bottom: 25px;
        }

        > div.sliderContainer {
            display: flex;
            justify-content: space-between;
            align-items: center;
            height: min(790px, 90vh);

            > img {
                cursor: pointer;
            }

            > div.slide {
                width: 100%;
                height: 100%;
                padding: 0 50px;
                display: flex;
                justify-content: center;
                align-items: center;

                > img, > video {
                    max-height: 100%;
                    max-width: 100%;
                }

                > a {
                    font-size: 30px;
                    text-transform: uppercase;
                }
            }
        }

        > span.credit {
            display: block;
            text-align: center;
            margin-top: 20px;
            font-size: 12px;
            color: gray;
        }

        > img.preload {
            width: 1px;
            height: 1px;
            opacity: 0.1;    
        }

        > div.infos {
            display: flex;
            justify-content: space-between;
            align-items: flex-start;
            margin-top: 55px;
            font-size: 20px;
            > p {
                width: calc(60% - 25px);
                > p {
                    white-space: pre-wrap;
                    display: -webkit-box;
                    text-overflow: ellipsis;
                    overflow: hidden;
                    -webkit-box-orient: vertical;
                    -webkit-line-clamp: 10;
                    &.deployed {
                        max-height: none;
                        -webkit-line-clamp: unset;
                    }
                }

                .otherProjLink {
                    text-decoration: none;
                    display: block;
                }

                > span.lirePlus {
                    color: blue;
                    cursor: pointer;
                }
            }
            > div {
                width: calc(40% - 25px);
            }
        }
    }
`

const Label = styled.span`
    font-size: 15px;
    font-weight: bold;
    text-transform: uppercase;
`

const Slider = (props) => {

    const [slideIndex, setSlideIndex] = React.useState(0);

    function nextSlide(){
        if(slideIndex < props.slides.length - 1){
            setSlideIndex(slideIndex + 1);
        } else {
            setSlideIndex(0);
        }
    }
    function previousSlide(){
        if(slideIndex > 0){
            setSlideIndex(slideIndex - 1);
        } else {
            setSlideIndex(props.slides.length - 1);
        }
    }

    if (props.slides.length === 0) return null;

    return (<>
        <div className='sliderContainer'>
            <img alt="" src="/img/flechegauche.png" onClick={previousSlide}/>
            <div className='slide'>
                {props.slides[slideIndex].type === 'image' &&
                    <img alt="" src={props.slides[slideIndex].src}/>
                }
                {props.slides[slideIndex].type === 'video' &&
                    <video src={props.slides[slideIndex].src} controls/>
                }
                {props.slides[slideIndex].type === 'pdf' &&
                    <a href={props.slides[slideIndex].src} target='_blank' rel='noreferrer'>
                        {props.i18n.language === "fr" ? "Voir le document" : "See the document"}
                    </a>
                }
            </div>
            <img alt="" src="/img/flechedroite.png" onClick={nextSlide}/>
        </div>
        <span className='thin centered credit'>© {props.slides[slideIndex].credit}</span>
        {/* display all images to preload them */}
        {props.slides.filter(slide => slide.type === 'image').map((slide,i) =>
            <img alt="" className='preload' key={i} src={slide.src}/>
        )}
    </>)
}

const FDFicheV2Projet = (props) => {

    const { i18n } = useTranslation('common');
    const [searchparams] = useSearchParams();
    const selectedProject = props.selectedProject;
    const [projetDeployed, setProjetDeployed] = React.useState(false);
    const [slides, setSlides] = React.useState([]);

    React.useEffect(() => {
        if(selectedProject){
            const _slides = [];
            for(let i = 0; i < selectedProject.files1.length; i++){
                const slide = {
                    src: "https://mediacenter.lefrenchdesign.org/userfiles/" + selectedProject.files1[i].uploaded_path,
                    type: selectedProject.files1[i].mimetype.includes('image') ? 'image' : (selectedProject.files1[i].mimetype.includes('video') ? 'video' : 'pdf'),
                    credit: selectedProject.credit1
                }
                _slides.push(slide);
            }
            for(let i = 0; i < selectedProject.files2.length; i++){
                const slide = {
                    src: "https://mediacenter.lefrenchdesign.org/userfiles/" + selectedProject.files2[i].uploaded_path,
                    type: selectedProject.files2[i].mimetype.includes('image') ? 'image' : (selectedProject.files2[i].mimetype.includes('video') ? 'video' : 'pdf'),
                    credit: selectedProject.credit2
                }
                _slides.push(slide);
            }
            for(let i = 0; i < selectedProject.files3.length; i++){
                const slide = {
                    src: "https://mediacenter.lefrenchdesign.org/userfiles/" + selectedProject.files3[i].uploaded_path,
                    type: selectedProject.files3[i].mimetype.includes('image') ? 'image' : (selectedProject.files3[i].mimetype.includes('video') ? 'video' : 'pdf'),
                    credit: selectedProject.credit3
                }
                _slides.push(slide);
            }
            setSlides(_slides);
        }
    }, [selectedProject])

    function echelleTranslate(echelle,lang){
        if(echelle === "Industrielle"){
            return lang === "fr" ? "Industrielle" : "Industrial scale"
        }
        if(echelle === "limitée"){
            return lang === "fr" ? "Edition limitée" : "Limited edition"
        }
        if(echelle === "unique"){
            return lang === "fr" ? "Pièce unique" : "Single piece"
        }
        return ""
    }

    function ouiNonYesNo(string,lang){
        if(lang === "fr"){
            return string
        } else {
            if(string === "oui"){
                return "yes"
            } else {
                return "no"
            }
        }
    }

    let précisionString = selectedProject.précisez;
    if(i18n.language === "fr" && selectedProject.précisezFR){
        précisionString = selectedProject.précisezFR;
    }
    if(i18n.language !== "fr" && selectedProject.précisezEN){
        précisionString = selectedProject.précisezEN;
    }

    return (
        <div>
            {selectedProject &&
                <MainContainerProjet>
                    <div>
                        <span className='catégorie'>{i18n.language === "fr" ? "Catégorie du projet" : "Project category"} : {selectedProject.categorie}</span><br/><br/>
                        <h1>{selectedProject.title}</h1>
                        <Slider
                            slides={slides}
                            i18n={i18n}
                        />
                        <div className='infos'>
                            <p>
                                <p className={'thin' + (projetDeployed ? ' deployed' : '')}>{i18n.language === "fr" ? selectedProject.description : selectedProject.descriptionen}</p><br/>
                                {projetDeployed ?
                                    <span className='lirePlus thin' onClick={() => setProjetDeployed(false)}>{i18n.language === "fr" ? "Afficher moins" : "Show less"}</span>
                                :
                                    <span className='lirePlus thin' onClick={() => setProjetDeployed(true)}>→ {i18n.language === "fr" ? "Lire plus" : "Read more"}</span>
                                }
                                {props.otherProjects && props.otherProjects.filter(proj => proj.confidential === "oui").length > 0 &&
                                    <div>
                                        <br/>
                                        <Label>{i18n.language === "fr" ? "Autres projets" : "Other projects"} :</Label><br/>
                                        {props.otherProjects.filter(proj => proj.confidential === "oui").map((project,i) =>
                                            <a className='otherProjLink thin' target='_blank' rel='noreferrer' href={'fdfichev2proj?email='+searchparams.get("email")+'&pid='+searchparams.get("pid")+'&projid='+project._id} key={i} >{project.title}</a>
                                        )}
                                    </div>
                                }
                            </p>
                            <div>
                                <Label>{i18n.language === "fr" ? "Année du projet" : "Project year"}</Label><br/>
                                <span className='thin capitalize'>{selectedProject.annee || '2022'}</span><br/><br/>
                                {selectedProject.type === "espace" && <>
                                    {selectedProject.adresse && <>
                                        <Label>{i18n.language === "fr" ? "Adresse" : "Address"}</Label><br/>
                                        <span className='thin capitalize'>{selectedProject.adresse}</span><br/><br/>
                                    </>}
                                    {selectedProject.fabrication && <>
                                        <Label>{i18n.language === "fr" ? "Le projet fait il appel à la fabrication française ?" : "Does the project use French manufacturing?"}</Label><br/>
                                        <span className='thin capitalize'>{ouiNonYesNo(selectedProject.fabrication,i18n.language)}.</span><br/>
                                        {selectedProject.fabrication === "oui" && selectedProject.précisez && <>
                                            <span className='thin capitalize'>{i18n.language === "fr" ? "Précision : " : "Precision: "}{précisionString}</span><br/>
                                        </>}
                                        <br/>
                                    </>}
                                </>}
                                {selectedProject.type === "objet" && <>
                                    {selectedProject.echelle && <>
                                        <Label>{i18n.language === "fr" ? "Echelle" : "Scale"}</Label><br/>
                                        <span className='thin capitalize'>{echelleTranslate(selectedProject.echelle,i18n.language)}</span><br/><br/>
                                    </>}
                                    {selectedProject.echelle === "Industrielle" && <>
                                        <Label>{i18n.language === "fr" ? "Fabricant" : "Manufacturer"}</Label><br/>
                                        <span className="thin capitalize">{selectedProject.fabricant}</span><br/><br/>
                                        <Label>{i18n.language === "fr" ? "Editeur" : "Editor"}</Label><br/>
                                        <span className="thin capitalize">{selectedProject.editeur}</span><br/><br/>
                                        <Label>{i18n.language === "fr" ? "Client / Distributeur" : "Client / Distributor"}</Label><br/>
                                        <span className="thin capitalize">{selectedProject.distributeur}</span><br/><br/>
                                        <Label>{i18n.language === "fr" ? "Pays de distribution" : "Country of distribution"}</Label><br/>
                                        <span className="thin capitalize">{selectedProject.pays}</span><br/><br/>
                                    </>}
                                    {(selectedProject.echelle === "limitée" || selectedProject.echelle === "unique") && <>
                                        <Label>{i18n.language === "fr" ? "Galerie" : "Gallery"}</Label><br/>
                                        <span className="thin capitalize">{selectedProject.galerie}</span><br/><br/>
                                        <Label>{i18n.language === "fr" ? "Editeur" : "Editor"}</Label><br/>
                                        <span className="thin capitalize">{selectedProject.editeur2}</span><br/><br/>
                                        <Label>{i18n.language === "fr" ? "Client / Distributeur" : "Client / Distributor"}</Label><br/>
                                        <span className="thin capitalize">{selectedProject.client}</span><br/><br/>
                                        <Label>{i18n.language === "fr" ? "Pays de distribution" : "Country of distribution"}</Label><br/>
                                        <span className="thin capitalize">{selectedProject.pays}</span><br/><br/>
                                    </>}
                                </>}
                                {selectedProject.awards && <>
                                    <Label>{i18n.language === "fr" ? "Awards & Presse internationale" : "Awards & International press"}</Label><br/>
                                    <span className='thin capitalize'>{selectedProject.awards}</span><br/><br/>
                                </>}
                            </div>
                        </div>
                    </div>
                </MainContainerProjet>
            }
        </div>
    );
};

export default FDFicheV2Projet;